import type { BoosterTypeController } from './types';
import { BoosterUndoModel } from '../../models/boosters/BoosterUndoModel';
import type { GameSceneController } from '../../../GameSceneController';
import { BoosterType } from '../../../boosters/types';
import { BoosterUndoAnimation } from '../../views/boosters/BoosterUndoAnimation';
import type { VersusSceneController } from '../../../../gameJam/VersusSceneController';

export class BoosterUndoController implements BoosterTypeController {
  public readonly isInstant = true;

  private readonly model: BoosterUndoModel;

  constructor(private readonly gameSceneController: GameSceneController | VersusSceneController) {
    this.model = new BoosterUndoModel(
      gameSceneController.getBoardModel(),
      gameSceneController.getTrayModel(),
      gameSceneController.getTasksTracker(),
    );
    gameSceneController.onUndoStateCreated.connect((saveData) => {
      this.model.addProgressData(saveData);
    });

    gameSceneController.onRevive.connect(() => {
      this.model.clearHistory();
    });

    gameSceneController.onBoosterUsed.connect((type) => {
      if (type === BoosterType.Undo) return;
      this.model.clearHistory();
    });
  }

  public canExecute(): boolean {
    return this.model.canExecute();
  }

  public execute(onComplete: (success: boolean) => void): this {
    if (!this.canExecute()) {
      onComplete(false);
      return this;
    }

    const view = new BoosterUndoAnimation().props({
      parent: this.gameSceneController.getSceneView().getUnderTopBarSlot(),
    });

    view
      .animate(() => {
        this.model.execute();

        const sceneView = this.gameSceneController.getSceneView();

        sceneView.getBoardView()?.reset();
        sceneView.getTopBarView().resetTasksGroup(this.gameSceneController.getTasksTracker().tasks);
      })
      .then(
        () => {
          onComplete(true);
        },
        () => {},
      );

    return this;
  }

  public cancel(): void {}
}
